// pdf.js 4+ stopped bundling its rendering assets. Without these URLs, any PDF
// whose text uses non-embedded standard fonts (Helvetica/Times — most
// Word-exported consents) silently renders no glyphs: the asset fetch 404s into
// the SPA's index.html fallback and the page paints only fills/rules (bug
// 12665806560 — kiosk consents showed highlight bars and no text). The dirs are
// copied same-origin to /pdfjs/* by each app's vite config, same self-hosting
// rationale as the pdf.js worker.
// Module-level const: react-pdf reloads the document if `options` changes identity.
export const PDF_DOCUMENT_OPTIONS = {
  standardFontDataUrl: '/pdfjs/standard_fonts/',
  cMapUrl: '/pdfjs/cmaps/',
  cMapPacked: true,
  wasmUrl: '/pdfjs/wasm/',
  iccUrl: '/pdfjs/iccs/',
};
